import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Main from '../views/Main.vue'

// Vue.use(VueRouter)

const routes: Array<RouteRecordRaw> = [
  {
    // vue-router 3
    // path: '*',
    // vue-router 4
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  },
  {
    path: '/login',
    name: '使用者登入',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/main',
    name: 'main',
    component: Main,
    meta: { requiresToken: true },
    redirect: '/door-status-list',
    children: [
      {
        path: '/door-status-list',
        name: '門鎖控制狀態',
        component: () => import('@/views/DoorStatusList.vue')
      },
      {
        path: '/role-list',
        name: '角色列表',
        component: () => import('@/views/RoleList.vue')
      },
      {
        path: '/user-list',
        name: '人員列表',
        component: () => import('@/views/UserList.vue')
      },
      {
        path: '/access-control-list',
        name: '門禁系統管理',
        component: () => import('@/views/AccessControlList.vue')
      }
    ]
  },
  {
    path: '/door-log-list/:id',
    name: '門鎖歷史紀錄',
    component: () => import('@/views/DoorLogList.vue')
  },
  {
    path: '/edit-password/:id',
    name: '重置密碼',
    component: () => import('@/views/EditPassword.vue')
  },
  {
    path: '/add-user',
    name: '新增人員',
    component: () => import('@/views/EditUser.vue')
  },
  {
    path: '/edit-user/:id',
    name: '編輯人員',
    component: () => import('@/views/EditUser.vue')
  },
  {
    path: '/add-role',
    name: '新增角色',
    component: () => import('@/views/EditRole.vue')
  },
  {
    path: '/edit-role/:id',
    name: '編輯角色',
    component: () => import('@/views/EditRole.vue')
  },
  {
    path: '/add-black-list',
    name: '新增黑名單',
    component: () => import('@/views/AddAccessControl.vue')
  },
  {
    path: '/add-white-list',
    name: '新增白名單',
    component: () => import('@/views/AddAccessControl.vue')
  }
]

// const router = new VueRouter({
//   routes,
//   mode: 'history'
// })

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresToken)) {
    if (window.localStorage.getItem('access_token') === null) {
      next({ path: '/login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

// router.beforeEach((to, form, next) => {
//   if (to.matched.some(record => {
//     return record.meta.requiresToken
//   })) {
//     if (window.localStorage.getItem('access_token') === null) {
//       next({ path: '/login' })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

export default router
